"use strict";

(function () {
  'use strict';

  angular.module('lr.core.controller', []).controller('AppCtrl', AppCtrl);
  AppCtrl.$inject = ['$rootScope', 'appNavService', 'authEvents', 'User', 'Utils', '$timeout', 'DataStreamFactory', 'EventSettingsFactory', '$filter', '$location', 'SocketBridge'];

  function AppCtrl($rootScope, appNavService, authEvents, User, Utils, $timeout, DataStreamFactory, EventSettingsFactory, $filter, $location, SocketBridge) {
    var vm = this;
    var EventStream = DataStreamFactory.generator();
    vm.ans = appNavService;
    vm.pageSize = 50;
    vm.eventFilters = EventSettingsFactory;
    vm.dateCtrls = Utils.DateKeeper;

    vm.getCount = function (viewArray) {
      if (viewArray) {
        return $filter('eventsFilter')(viewArray, vm.eventFilters.eventFilters).length;
      } else {
        return 0;
      }
    };

    vm.logout = function () {
      $rootScope.$broadcast(authEvents.logout);
    };

    vm.viewEvents = function () {
      EventStream.resetUnseenEvents();
    };

    function activate() {
      var token = User.getToken();

      if (token) {
        vm.user = token;
      }

      vm.onRecentToggle = function (status) {
        if (!status) {
          EventStream.resetUnseenEvents();
        }
      };
    }

    $rootScope.$on(authEvents.success, function () {
      $location.path('/'); //pass the application event to the application

      $timeout(function () {
        //publish the user is auth
        Utils.Publisher.publish(authEvents.success, null); //init event stream and connect to socket server

        EventStream.init(); //add the event stream to the vm

        vm.liveEvents = EventStream;
      }, 500); //activate on auth success

      activate();
    });
    $rootScope.$on(authEvents.login, function () {}); //on user logout

    $rootScope.$on(authEvents.logout, function () {
      $location.path('/login');
      EventStream.unsubscribe();
    });
  }
})();